const STORAGE_KEY = 'surahProgress';

let cache = null;

function loadFromStorage() {
  if (typeof localStorage === 'undefined') return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed;
  } catch {
    return {};
  }
}

function saveToStorage(map) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map || {}));
  } catch {}
}

export function getSurahProgressMap() {
  if (!cache) {
    cache = loadFromStorage();
  }
  return cache || {};
}

export function setSurahProgressMap(next) {
  cache = next || {};
  saveToStorage(cache);
}

export function updateSurahProgress(surahId, ayah) {
  if (!Number.isFinite(surahId) || !Number.isFinite(ayah)) return;
  const current = getSurahProgressMap();
  const prev = Number(current[surahId] || 0);
  if (ayah <= prev) return;
  const next = { ...(current || {}), [surahId]: ayah };
  setSurahProgressMap(next);
  try {
    window.dispatchEvent(new CustomEvent('surahProgressChanged', {
      detail: { surahId, ayah },
    }));
  } catch {}
}

export function clearSurahProgress() {
  setSurahProgressMap({});
}
